import { FormatDateOptions, formatDate, isDateFormat } from './dates'
import { withUnicodeRouteArrow } from './routeLabelDisplay'

export const EMPTY_VALUE_DEFAULT = '-'
export const MULTIPLE = 'Multiple'

export const addZeroBefore = (digit: number) => {
  return (digit < 10 ? '0' : '') + digit
}

export const isValidValue = (value: any) => {
  return !value || value === EMPTY_VALUE_DEFAULT || value === MULTIPLE
}

export const dateIsValid = (date: any) => {
  return date instanceof Date || !isNaN(date)
}

// Seen 3 different formats for time, so just checking for the date portion.
// const ServerTimeRegExp = RegExp('^[0-9]{4}-[0-9]{2}-[0-9]{2}.*$')

export const isEmptyValue = (value: any): value is null | undefined => {
  return (
    value === null ||
    value === undefined ||
    value === '' ||
    typeof value === 'function'
  )
}

export const valueTransformer = (
  value: any,
  dateOptions?: FormatDateOptions,
): string => {
  const valueType = typeof value

  if (isEmptyValue(value)) {
    return '-'
  }

  if (Array.isArray(value) || valueType === 'object') {
    return JSON.stringify(value)
  }

  if (isDateFormat(value)) {
    return formatDate(value, dateOptions)!
  }

  return withUnicodeRouteArrow(`${value}`)
}
